import React from 'react'

import CheckBox from '../../../../../../../UI/Forms/Checkbox/Checkbox'

const employeeSelector = ({ selected, onSelect }) => {
  return <CheckBox changed={onSelect} checked={selected}/>
}

export default employeeSelector
